import { useState } from "react";
import { useApplication } from "../ApplicationContext";
import { useLenderOperations } from "src/hooks/useLenderOperations";
import { PrimaryButton } from "src/components/Buttons";
import { useLenderDocuments } from "src/hooks/useLenderDocuments";
import {
  Container,
  HeaderRow,
  HeaderTitleContainer,
  HeaderTitle,
  HeaderSubtitle,
  IconWrapper,
  AvailableLenderRow,
  Monogram,
  LenderContainer,
  ButtonGroup,
  ActionsWrapper,
} from "./SendApplicationWidget.styles";
import { AiContentGeneratorIcon, UploadCircleIcon } from "src/assets/icons";
import Dropdown from "src/components/Dropdown";
import { FilePDFIcon } from "src/assets/icons";

export default () => {
  const [currentlySubmittedLender, setCurrentlySubmittedLender] = useState<
    string | null
  >(null);
  const { application, refetchApplication } = useApplication();
  const { submitToLender } = useLenderOperations(
    application,
    refetchApplication,
  );
  const primaryLender = application?.lenders?.find(
    (lender) => lender.id === application?.primary_lender,
  );
  const { hasLenderDocuments, loading, downloadLenderDocument } =
    useLenderDocuments(
      application?.application_id || "",
      primaryLender?.id || "",
    );

  const onLenderSubmit = (lender_id: string) => {
    setCurrentlySubmittedLender(lender_id);

    return submitToLender(lender_id)
      .then(() => {
        setCurrentlySubmittedLender(null);
      })
      .catch((_error) => {
        // Error handling is done in context
      });
  };
  return (
    <Container>
      <HeaderRow>
        <HeaderTitleContainer>
          <HeaderTitle>Ready to Submit</HeaderTitle>
          <HeaderSubtitle>
            The application is ready to submit to the selected lender.
          </HeaderSubtitle>
        </HeaderTitleContainer>
        <IconWrapper>
          <AiContentGeneratorIcon />
        </IconWrapper>
      </HeaderRow>
      <AvailableLenderRow key={primaryLender?.name}>
        <LenderContainer>
          <Monogram>{primaryLender?.name?.charAt(0)}</Monogram>
          {primaryLender?.name}
        </LenderContainer>

        <ButtonGroup>
          <ActionsWrapper visible={hasLenderDocuments && !loading}>
            <Dropdown
              displayText="Actions"
              menuItemsObj={{
                view: { label: "View Application", icon: <FilePDFIcon /> },
              }}
              selectedItem=""
              onSelectedItemChange={(value) => {
                if (value === "view") {
                  void downloadLenderDocument(
                    `application-${application?.application_id}.pdf`,
                    true,
                  );
                }
              }}
              hideCheckmark
            />
          </ActionsWrapper>
          <PrimaryButton
            onClick={() => void onLenderSubmit(primaryLender?.id || "")}
            loading={primaryLender?.id === currentlySubmittedLender}
          >
            Submit to lender
            <UploadCircleIcon />
          </PrimaryButton>
        </ButtonGroup>
      </AvailableLenderRow>
    </Container>
  );
};
